<template>
	<span>
		<input type="text" class="tbl_int" :value="value" :disabled="disabled" autocomplete="off" style="width:300px;" @input="updateValue" @keydown.enter="enterEvent" @focus="selectOnClick ? $event.target.select() : ''" />

		<button :disabled="disabled" @click="selectItemClass()">...</button>

		<Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">Select Item {{ headers.class }}</template>
			<template slot="body">
				<ItemClassPopup v-on:close="closeModal()" :close_on_select="false" @set-item-class="setItemClass" />
			</template>
		</Modal>
	</span>
	<!-- <select ref="dl" :class="className" v-bind:style="'width:' + width + 'px;'"></select> -->
</template>

<script>
import { apiSelectItemClass } from '@/api/item/class.js';
import ItemClassPopup from '@/components/common/ItemClassPopup';
import Modal from '@/components/common/Modal';
export default {
	data: function() {
		return {
			//code: null,
			//name: this.initialName,
			// dl: null,
			// desc: null,
			//values: [],
			//values_string: null,
			showModal: false,
		};
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
	},
	// computed: {
	// 	values_string: {
	// 		get: function() {
	// 			return this.values.join();
	// 		},
	// 		set: function(newValue) {
	// 			this.values = newValue.split(',');
	// 		},
	// 	},
	// },
	components: {
		ItemClassPopup,
		Modal,
	},
	props: {
		//values: Array,
		value: String,

		disabled: {
			type: Boolean,
			default: false,
		},

		selectOnClick: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		updateValue: function(event) {
			this.$emit('input', event.target.value);
			//this.values = event.target.value.split(',');
			//console.log(event.target.value);
			//console.log(this.values);
		},
		selectItemClass() {
			this.showModal = true;
		},
		enterEvent() {
			this.$emit('keydown');
		},
		closeModal() {
			this.showModal = false;
		},
		setItemClass(itemClass) {
			if (this.value) {
				var values = this.value.split(',');
				if (values.indexOf(itemClass.code) === -1) {
					this.$emit('input', this.value + ',' + itemClass.code);
				}
			} else {
				this.$emit('input', itemClass.code);
			}
		},
		async search() {
			var keyword = this.value.trim();
			if (!keyword) return;

			//console.log('search....', '*' + keyword + '*');
			const { data } = await apiSelectItemClass({
				code: keyword,
			});
			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			//this.partners = data.partnerList;
			if (data.itemClass) {
				this.setItemClass(data.itemClass);
			} else {
				this.name = '';
				this.$emit('input', null);
				let text = `Item ${this.headers.class} Code of ${this.keyword} Not Found`;
				this.$toast.error(text);
			}
		},
	},
	mounted() {
		// $("input[type='text'], input[type='number']").on('click', function() {
		// 	console.log('test');
		// 	//$(this).select();
		// });
	},
};
</script>

<style></style>
